import { GenericMoleculeOverviewRowPanelDashboardComponent } from '../abstract';

// tslint:disable-next-line:max-line-length
export class MoleculeOverviewRowPanelDashboardDomainsComponent extends GenericMoleculeOverviewRowPanelDashboardComponent {
    public template = require('./dashboard-domains.html');
    protected type = 'domains';
}
